import Axios from 'axios';
import Qs from 'qs';

export default {

  // 住户分页列表
  listPage(
    community_id,
    housing_id,
    name,
    mobile,
    identity,
    audit_type,
    page,
    limit
  ) {
    let filter = {
      name,
      mobile,
      identity,
      audit_type
    };
    if (housing_id) {
      filter.housing_id = housing_id;
    }
    return Axios.get('/community/api/admin/owners/list', {
      params: {
        filter,
        sort: {
          id: 'desc'
        },
        community_id,
        page,
        limit
      },
      paramsSerializer(params) {
        return Qs.stringify(params);
      }
    });
  },

  // 新增住户
  add(
    community_id,
    name,
    id_card,
    mobile,
    housing_id,
    move_into_date,
    identity,
    owner_tag_id,
    audit_type
  ) {
    return Axios.post('/community/api/admin/owners/store', {
      community_id,
      name,
      id_card,
      mobile,
      housing_id,
      move_into_date,
      identity,
      owner_tag_id,
      audit_type
    });
  },

  // 编辑住户
  edit(
    community_id,
    id,
    name,
    id_card,
    mobile,
    housing_id,
    move_into_date,
    identity,
    owner_tag_id,
    audit_type
  ) {
    return Axios.patch(`/community/api/admin/owners/update/${id}`, {
      community_id,
      name,
      id_card,
      mobile,
      housing_id,
      move_into_date,
      identity,
      owner_tag_id,
      audit_type
    });
  },

  // 住户信息
  info(
    id
  ) {
    return Axios.get(`/community/api/admin/owners/show/${id}`);
  },

  // 审核
  review(
    id
  ) {
    return Axios.patch(`/community/api/admin/owners/${id}/audit`);
  },

  // 驳回
  overrule(
    id
  ) {
    return Axios.patch(`/community/api/admin/owners/${id}/no-audit`);
  },

  // 删除住户
  del(
    id
  ) {
    return Axios.delete(`/community/api/admin/owners/${id}/delete`);
  },

  // 是否有新住户
  isNew() {
    return Axios.get(`/community/api/admin/owners/tips`);
  },
  // 启用人脸状态
  enableFace(id) {
    return Axios.post(`/community/api/admin/owners/enable-face/${id}`);
  },
  // 禁用人脸状态
  disableFace(id) {
    return Axios.post(`/community/api/admin/owners/disable-face/${id}`);
  },
  // 导入
  import(params) {
    return Axios.post(`/community/api/admin/owners/importOwner`, params)
  }
}